@if (meet) {
  <div #backgroundCurtain class="background-curtain" (click)="isSidebarOpenService.toggleSidebar()"></div>
  <div #secondSideMenu class="d-flex flex-column flex-shrink-0 p-3 second-side-menu">
    @if (siteConfig$ | async; as siteConfig) {
      @if (!siteConfig.ngConfig.primarySite) {
        <div class="mb-3 text-center">
          @if ({ value: isDarkMode$ | async }; as isDarkMode) {
            @if (isDarkMode.value) {
              <a [href]="siteConfig.ngConfig.siteUrl">
                <img
                  style="height: 50px; max-width: 250px"
                  [src]="siteConfig.ngConfig.sideMenuImageDarkModeUrl"
                  [alt]="siteConfig.ngConfig.siteName"
                />
              </a>
            } @else {
              <a [href]="siteConfig.ngConfig.siteUrl">
                <img
                  style="height: 50px; max-width: 250px"
                  [src]="siteConfig.ngConfig.sideMenuImageUrl"
                  [alt]="siteConfig.ngConfig.siteName"
                />
              </a>
            }
          }
        </div>
      }
    }
    <div class="fs-4">
      {{ meet.name }}
    </div>
    <div class="fs-6 mb-3 pb-3 border-bottom">
      {{ meet.meetDates | meetDate: meet.timeFormat : meet.dateString }}
    </div>
    <div class="pb-3">
      <app-sidebar-search></app-sidebar-search>
    </div>
    <app-timezone-toggle></app-timezone-toggle>
    <app-locale-toggle></app-locale-toggle>

    @if (meet.videoLink || (meet.athleticNetId && meet.athleticNetId > 0)) {
      <div class="list-group mb-3">
        @if (meet.videoLink) {
          <a href="{{ meet.videoLink }}" target="_blank" class="list-group-item">
            <fa-icon class="me-2" [icon]="environment.icons.video" [fixedWidth]="true"></fa-icon>
            <span i18n="Watch Live Title on the Main sidebar@@mobileSidebar.watchLiveTabTitle">Watch Live</span>
          </a>
        }
        @if (meet.athleticNetId && meet.athleticNetId > 0) {
          <a href="{{ meet.athleticNetMeets[0].url }}" target="_blank" class="list-group-item list-group-item-action">
            <img
              src="https://s3.amazonaws.com/media.athletic.net/athletic-logos/square/logo-gradient.svg"
              width="20"
              class="me-2"
            />
            <span i18n="@@mobileSidebar.viewOnAthleticNet">View on AthleticNET</span>
          </a>
        }
      </div>
    }
    <div class="list-group mb-3">
      <a
        routerLink="/meets/{{ meet.id }}"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item"
      >
        <fa-icon class="me-2" [icon]="environment.icons.home" [fixedWidth]="true"></fa-icon>
        <span i18n="Home Tab Title on the Main sidebar@@mobileSidebar.homeTabTitle">Home</span>
      </a>
      @if (meet.allowFieldScoreboard || meet.allowScoreboard) {
        <a
          routerLink="/meets/{{ meet.id }}/live"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="list-group-item"
        >
          <fa-icon class="me-2" [icon]="environment.icons.live" [fixedWidth]="true"></fa-icon>
          <span i18n="Live Tab Title on the Main sidebar@@mobileSidebar.liveTabTitle">Live</span>
        </a>
      }
      <a
        routerLink="/meets/{{ meet.id }}/events"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item"
      >
        <fa-icon class="me-2" [icon]="environment.icons.events" [fixedWidth]="true"></fa-icon>
        <span i18n="Events Tab Title on the Main sidebar@@mobileSidebar.eventsTabTitle">Events</span>
      </a>
      <!-- Check-In -->
      @if (meet.checkIn) {
        <a
          routerLink="/meets/{{ meet.id }}/checking-in-now"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="list-group-item"
        >
          <fa-icon class="me-2" [icon]="environment.icons.doorOpen" [fixedWidth]="true"></fa-icon>
          <span i18n="Check-In Tab Title on the Main sidebar@@mobileSidebar.checkInTabTitle">Check-In</span>
        </a>
      }
      <a
        routerLink="/meets/{{ meet.id }}/follow"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item d-flex align-items-center"
      >
        <fa-icon class="me-2" [icon]="environment.icons.followOn" [fixedWidth]="true"></fa-icon>
        <span i18n="Follow Tab Title on the Main sidebar@@mobileSidebar.followTabTitle">Follow</span>
        @if (followInfo$ | async; as followInfo) {
          <span class="mx-2 badge text-bg-primary rounded-pill"
            >{{ followInfo.athletes.length + followInfo.teams.length + followInfo.aliveFollows.length }}
          </span>
        }
      </a>
      <a
        routerLink="/meets/{{ meet.id }}/teams"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item"
      >
        <fa-icon class="me-2" [icon]="environment.icons.teams" [fixedWidth]="true"></fa-icon>
        <span i18n="Teams Tab Title on the Main sidebar@@mobileSidebar.teamsTabTitle">Teams</span>
      </a>
      <a
        routerLink="/meets/{{ meet.id }}/athletes"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="list-group-item"
      >
        <fa-icon class="me-2" [icon]="environment.icons.athletes" [fixedWidth]="true"></fa-icon>
        <span i18n="Athletes Tab Title on the Main sidebar@@mobileSidebar.athletesTabTitle">Athletes </span>
      </a>
      @if (meet.scoreMeet && meet.meetScores) {
        @if (meet.sport !== 'xc') {
          <a routerLink="/meets/{{ meet.id }}/track-scores" routerLinkActive="active" class="list-group-item">
            <fa-icon class="me-2" [icon]="environment.icons.scores" [fixedWidth]="true"></fa-icon>
            <span i18n="Team Scores Tab Title on the Main sidebar@@mobileSidebar.scoresTabTitle">Scores</span>
          </a>
        }
      }
      @if (meet.hasMedia && meet.hasMediaPhotos) {
        <a routerLink="/meets/{{ meet.id }}/media/photos" routerLinkActive="active" class="list-group-item">
          <fa-icon class="me-2" [icon]="environment.icons.images" [fixedWidth]="true"></fa-icon>
          <span i18n="Photos Tab Title on the Main sidebar@@mobileSidebar.photosTabTitle">Photos</span>
        </a>
      }
      <!-- <a routerLink="/meets/{{ meet.id }}/media/videos" routerLinkActive="active" class="list-group-item">
        <fa-icon class="me-2" [icon]="environment.icons.video" [fixedWidth]="true"></fa-icon>
        <span i18n="Videos Tab Title on the Main sidebar@@mobileSidebar.videosTabTitle">Videos</span>
      </a> -->
    </div>
    @if (meet.athleticNetId === -1 && meet.athleticNetMeets && meet.athleticNetMeets.length > 0) {
      <div ngbAccordion [destroyOnHide]="false" class="mb-3">
        <div ngbAccordionItem>
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>
              <img
                src="https://s3.amazonaws.com/media.athletic.net/athletic-logos/square/logo-gradient.svg"
                width="20"
                class="me-2"
              />
              <span i18n="@@mobileSidebar.viewOnAthleticNet2">View on AthleticNET</span>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="p-0">
              <ng-template>
                <div class="list-group list-group-flush">
                  @for (anetMeet of meet.athleticNetMeets; track anetMeet) {
                    <a href="{{ anetMeet.url }}" target="_blank" class="list-group-item list-group-item-action">
                      <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
                      {{ anetMeet.name }}
                    </a>
                  }
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="list-group mb-3">
      @for (meetLink of meet.meetLinks; track meetLink) {
        <a href="{{ meetLink.url }}" target="_blank" class="list-group-item">
          <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
          <span>{{ meetLink.name }}</span>
        </a>
      }
      <a routerLink="/meets/{{ meet.id }}/reports/winners" class="list-group-item" routerLinkActive="active">
        <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
        <span i18n="Winners Tab Title on the Main sidebar@@mobileSidebar.winnersTabTitle">Winners </span>
      </a>
      @if (meet.hasRecords) {
        <a routerLink="/meets/{{ meet.id }}/reports/records" class="list-group-item" routerLinkActive="active">
          <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
          <span i18n="Records Tab Title on the Main sidebar@@mobileSidebar.recordsTabTitle">Records </span>
        </a>
      }
      @if (meet.hasTimeStandards) {
        <a routerLink="/meets/{{ meet.id }}/reports/time-standards" class="list-group-item" routerLinkActive="active">
          <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
          <span i18n="Time Standards Tab Title on the Main sidebar@@mobileSidebar.timeStandardsTabTitle"
            >Event Standards
          </span>
        </a>
      }
      @if (meet.hasTrackPointMvp) {
        <a routerLink="/meets/{{ meet.id }}/reports/track-point-mvp" class="list-group-item" routerLinkActive="active">
          <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
          <span i18n="MVP Tab Title on the Main sidebar@@mobileSidebar.mvpTabTitle">MVP </span>
        </a>
      }
      <a
        [routerLink]="undefined"
        routerLinkActive="active"
        class="list-group-item"
        (click)="onDarkModeToggle()"
        role="button"
      >
        @if ({ value: isDarkMode$ | async }; as isDarkMode) {
          @if (isDarkMode.value) {
            <fa-icon class="me-2" [icon]="environment.icons.lightMode" [fixedWidth]="true"></fa-icon>
            <span i18n="Change to Light Mode on the Main sidebar@@mobileSidebar.lightModeTabTitle">Light Mode </span>
          } @else {
            <fa-icon class="me-2" [icon]="environment.icons.darkMode" [fixedWidth]="true"></fa-icon>
            <span i18n="Change to Dark Mode on the Main sidebar@@mobileSidebar.darkModeTabTitle">Dark Mode </span>
          }
        }
      </a>
    </div>

    <h5>
      <fa-icon [icon]="environment.icons.location" [fixedWidth]="true" class="me-2"></fa-icon>
      <span i18n="@@mobileSidebar.location">Location</span>
    </h5>
    <p>
      {{ meet.location }} (<a
        target="_blank"
        href="https://www.google.com/maps?saddr=Current+Location&daddr={{ meet.location }}"
        >Get Directions</a
      >)
    </p>
  </div>
}
